import React from 'react';
import styles from './style.module.scss';

export interface FpIconButtonProps {
  icon: JSX.Element
  onClick?: () => void
}

export function FpIconButton(props: FpIconButtonProps) {
  return (
    <button
      className={`${styles['search-button']} k-button k-button-md k-button-solid k-button-solid-base`}
      onClick={props.onClick}
      type="button"
    >
      {props.icon}
    </button>
  );
}
